import { overlayStore, quizStore, categoryStore } from '@/store';
import { mediaQueriesMixin } from './mediaQueries';

export const overlayMixin = {
    mixins: [mediaQueriesMixin],
    data() {
        return {
            popupCounter: 0,
            mouseX: 0,
            mouseY: 0,
            categoryState: categoryStore.state,
            overlayState: overlayStore.state,
            quizState: quizStore.state,
            lastScrollTop: 0,
            triggerPoint: null,
            exitOverLayCounter: null,
        };
    },
    props: {
        host: {
            type: Object,
        },
    },
    computed: {
        showExitOverlay() {
            // Show Overlay when: Questionnaire is not visible, Not on article page
            // Hide Overlay once popupCounter has reached its limit
            if (
                this.popupCounter < 1 &&
                !this.quizState.showQuestionnaire &&
                !this.$route.path.startsWith('/article')
            ) {
                return !!(
                    this.isOverlayActive() &&
                    this.categoryState.rankingTableIsLoaded
                );
            }
        },
        popupOpen() {
            return this.overlayState.popupOpen;
        },
    },
    methods: {
        scrollThreshold() {
            return this.isMobileDevice() ? 0.1 : 0.4;
        },
        checkPopup() {
            let overlayConditions =
                this.popupCounter < 1 && !this.quizState.showQuestionnaire;

            if (this.$globalConstants.host.exit_overlay && overlayConditions) {
                if (this.overlayState.popupOpen === false) {
                    this.trackExitOverlayEvent();
                }
                this.overlayState.popupOpen = true;
            }
            if (this.exitOverLayCounter) {
                clearTimeout(this.exitOverLayCounter);
            }
        },
        isOverlayActive() {
            return (
                this.$globalConstants.host['exit_overlay'] &&
                this.$globalConstants.host['exit_overlay']['use_overlay']
            );
        },
        trackExitOverlayEvent() {
            const event = {
                event: 'exit_popup_impression',
                label: 'exit_popup_impression',
                action: 'exit_popup_impression',
            };

            if (window.track) {
                window.track.event(event);
            }
        },
        closePopupOverlay() {
            this.overlayState.popupOpen = false;
            this.popupCounter++;
        },
        onScroll() {
            let scrollHeight = document.body.scrollHeight;
            let scrollTop = window.scrollY;

            // Set a marker (scroll position from top) once user begins to scroll up
            if (
                scrollTop >= scrollHeight * this.scrollThreshold() &&
                scrollTop < this.lastScrollTop &&
                !this.triggerPoint
            ) {
                this.triggerPoint = scrollTop;
                // Show popup once user has scrolled up 5% of page height from set marker
            } else if (
                scrollTop < this.lastScrollTop &&
                this.triggerPoint - scrollTop > scrollHeight * 0.05
            ) {
                this.overlayState.popupOpen = true;
                window.removeEventListener('scroll', this.onScroll, true);
            }

            this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        },
        addEvent(evt, fn) {
            if (document.addEventListener) {
                document.addEventListener(evt, fn, false);
            }
        },
        removeEvent(evt, fn) {
            if (document.removeEventListener) {
                document.removeEventListener(evt, fn, false);
            }
        },
        clearTimer() {
            if (this.exitOverLayCounter) {
                clearTimeout(this.exitOverLayCounter);
            }
        },
        triggerOverlayWhenUserInDifferentTab() {
            if (!document.hidden) return;
            this.clearTimer();
            // this.exitOverLayCounter = setTimeout(() => {
            //     console.log('triggerOverlayWhenUserInDifferentTab');
            //     this.checkPopup();
            // }, 5000);
        },
        triggerOverLayWhenUserReachAddressBar(evt) {
            if (evt['relatedTarget']) {
                return;
            }

            this.clearTimer();

            this.exitOverLayCounter = setTimeout(() => {
                this.checkPopup();
            }, 600);
        },
    },
    created() {
        if (!this.isOverlayActive()) return;
        this.addEvent(
            'visibilitychange',
            this.triggerOverlayWhenUserInDifferentTab
        );
        // this.addEvent('scroll', this.onScroll);
        this.addEvent('mouseout', this.triggerOverLayWhenUserReachAddressBar);
    },
    beforeDestroy() {
        if (!this.isOverlayActive()) return;

        this.clearTimer();
        this.removeEvent(
            'visibilitychange',
            this.triggerOverlayWhenUserInDifferentTab
        );
        // this.removeEvent('scroll', this.onScroll, true);
        this.removeEvent(
            'mouseout',
            this.triggerOverLayWhenUserReachAddressBar
        );
    },
};
